import React from 'react';
import { ChevronDown } from 'lucide-react';
interface SelectOption {
  value: string;
  label: string;
}
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: SelectOption[];
  error?: string;
  placeholder?: string;
}
export function Select({
  label,
  options,
  error,
  className = '',
  placeholder = 'Select an option',
  id,
  ...props
}: SelectProps) {
  const selectId = id || props.name || Math.random().toString(36).substr(2, 9);
  return <div className="w-full" data-id="element-223">
      {label && <label htmlFor={selectId} className="block text-sm font-medium text-gray-700 mb-1" data-id="element-224">
          {label}
        </label>}
      <div className="relative" data-id="element-225">
        <select id={selectId} className={`
            w-full px-4 py-2 pr-10 rounded-lg border bg-white appearance-none transition-colors duration-200
            focus:outline-none focus:ring-2 focus:ring-[#1e3a5f] focus:border-transparent
            disabled:bg-gray-100 disabled:text-gray-500
            ${error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300'}
            ${className}
          `} {...props} data-id="element-226">
          <option value="" disabled selected data-id="element-227">
            {placeholder}
          </option>
          {options.map(option => <option key={option.value} value={option.value} data-id="element-228">
              {option.label}
            </option>)}
        </select>
        <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" data-id="element-229">
          <ChevronDown className="h-4 w-4 text-gray-500" data-id="element-230" />
        </div>
      </div>
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-231">{error}</p>}
    </div>;
}